import { AxiosRequestConfig } from 'axios';
import {
  computed,
  ref,
} from 'vue';
import { keycloak } from '../keycloak';
import { useUserStore } from '@/shared/store/useUserStore';
import { callAfterAppReady } from '@/callAfterAppReady';

export const ownerEmail = ref('');
// Список слов из урлов которым не нужен email
const apiStopWords = ['products', 'relatives', 'welcomeBonus', 'contactTracking', '?include=statusDetail', 'subCategories', 'productTypes', 'brands', 'categories', 'deliveryNotes'];
// Список слов из урлов в которых параметр email нужно менять на ownerEmail
const apiReplaceToOwnerEmailWords = ['recommendations'];

// eslint-disable-next-line camelcase
declare let window: {
  location: any,
  // eslint-disable-next-line camelcase
  keycloak: {tokenParsed: {resource_access: {svc: {roles: string[]}}}}
};

export const useViewAsOwner = () => {
  /**
   * Проверяем может ли юзер смотреть от другого юзера
   */
  const isMeetPermissions = computed(() => {
    const roles = keycloak.value?.tokenParsed?.resource_access?.svc?.roles ?? [];

    return roles.filter((role: string) => [
      'admin',
      'manager',
      'tokens-admin',
      'tokens-manager',
    ].includes(role)).length > 0;
  });

  /**
   * Считываем имейл из строки запроса
   * @param route
   */
  const initViewAsOwner = () => {
    const url = new URL(window.location.href);

    if (!isMeetPermissions.value) {
      return;
    }

    if (url.searchParams.get('ownerEmail')) {
      ownerEmail.value = String(url.searchParams.get('ownerEmail'));
      callAfterAppReady(() => {
        const userStore = useUserStore();
        userStore.setUserEmailFromKC(ownerEmail.value);
      });
    }
  };

  /**
   * Axios интерсептор перед отправкой запроса к бэку
   * @param config
   */
  const axiosRequestInterceptor = (config: AxiosRequestConfig) => {
    if (!ownerEmail.value) {
      return;
    }

    if (!isMeetPermissions.value) {
      return;
    }

    if (config.method !== 'get' && config.method !== 'head') {
      throw new Error('Запрещено совершать операции');
    }

    const url = config.url ?? '';
    const hasStopWords = apiStopWords.filter(word => url.indexOf(word) > -1).length !== 0;
    const isNeedReplace = apiReplaceToOwnerEmailWords.filter(
      word => url.indexOf(word) > -1,
    ).length !== 0;
    let emailGetUrlName = 'email';

    if (isNeedReplace) {
      emailGetUrlName = 'ownerEmail';
    }

    if (!hasStopWords) {
      config.params = { ...config.params, [emailGetUrlName]: ownerEmail.value };
    }
  };

  return {
    ownerEmail,
    initViewAsOwner,
    axiosRequestInterceptor,
  };
};
